import { PurlTrackingService } from "@/services/purlTracking.service";

export default {
  setPurlId({ commit }, purlId) {
    if (purlId) {
      const isPreview =
        purlId?.includes("preview.") || purlId === "purlId not included";
      if (isPreview) {
        const previewPurl = purlId.split("preview.");
        purlId = previewPurl.pop();
      }
      commit("SET_PURL_ID", purlId);
      commit("SET_IS_PREVIEW", isPreview);
    }
  },
  setPurlInfo({ commit, dispatch, state }, purl) {
    commit("SET_PURL_INFO", purl);

    // //* Initial purl visit tracking
    if (!state?.isPreview) {
      dispatch("purlVisit");
    }
  },
  setCmsInfo({ commit, dispatch, state }, cms) {
    commit("SET_CMS_INFO", cms);
  },
  purlVisit({ commit, state }) {
    PurlTrackingService.purlVisit(state.id).then((sessionDbId) => {
      commit("SET_SESSION_DB_ID", sessionDbId);
    });
  },
  purlPageTracking({ state }, { sectionId }) {
    if (!sectionId || !state.id || !state.sessionDbId) return;
    PurlTrackingService.trackPage(state.id, state.sessionDbId, sectionId);
  },
};
